<div class="landings-bookyup-system">
    <!-- header start here -->
    <header id="home-page-header-section">
        <nav class="navbar navbar-expand-lg">
            <div class="container">
              <a class="navbar-brand" href="/">
                <img src="../../assets/images/home-new-static/header/logo-header.png" alt="">
              </a>
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <a class="nav-link active" aria-current="page"  href="/home#home-page-header-section">Home</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/about-us#about-us-header-section">About Us</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="https://career.bookyup.co.uk/" target="_blank">Career</a>
                  </li>
                </ul>

                <div class="button-div">
                    <a class="book-btn" href="/home#contact-form-main">
                        Become a partner
                    </a>
                </div>
              </div>
            </div>
        </nav>
    </header>
    <!-- header start here -->

    <!-- banner section start here -->
    <section class="banner-sec-homepage">
        <div class="container">
            <div class="row">
                <div class="col-lg-12" data-aos="fade-up">
                    <h5>Grow your</h5>
                    <h3>Restaurant's</h3>
                    <h1>Online Reach</h1>
                    <p>Attract more customers with a personalised website, app, and proven marketing solutions that drive online orders for your business.</p>
                    <a class="book-btn" href="#three-sec-all-process">Discover How!</a>
                </div>
            </div>
        </div>
    </section>
    <!-- banner section end here -->


    <!-- bottom-banner start here -->
    <section class="home-page-banner">
        <div class="container">
            <div class="row justify-content-center align-items-center">
                <div class="col-lg-6" data-aos="fade-right">
                    <div class="text-div">
                        <h1 class="mb-3" id="highlight-effect">
                            Welcome To   <br> <span class="highlight">Bookyup</span>
                        </h1>
                        <h6 class="mb-5">Bookyup is an online marketing company focused on helping restaurants grow by enhancing their online presence. With our restaurant-first marketing approach, we create strategies that directly cater to the needs of food businesses, connecting them with the right audience. We offer a variety of services that are designed to drive results and build strong customer connections.</h6>
                        <a class="book-btn m-0" href="/home#contact-form-main">Get Started</a>
                    </div>
                </div>
                <div class="col-lg-6" data-aos="fade-left">
                    <div class="image-div">
                        <img class="w-100" src="../../../assets/images/home-new-static/banner/banner1.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- bottom-banner end here  -->

    <!-- <section class="logoMarqueeSection" style="background-color: #837359; overflow: hidden;" data-aos="zoom-in">
        <h3 class="text-center">Trusted by Restaurants Across the UK</h3>
            <p class="text-center mb-5">Join the growing list of food businesses thriving with our innovative marketing solutions.</p>
        <div class="container" id="logoMarqueeSection">
            <div class="default-content-container flex items-center">
                <div class="default-content-container-inner marquee-wrapper relative overflow-hidden inline-block">
                    <div class="marquee" style="animation-duration: 57s;">
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/1.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/2.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/3.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/4.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/5.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/6.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/7.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/8.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/9.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                    </div>
            <div class="marquee" style="animation-duration: 57s;">
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/1.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/2.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/3.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/4.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/5.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/6.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/7.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/8.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                        <a target="_blank"><img src="../../assets/images/home-new-static/new logo/9.png" title="" class="marqueelogo" style="width: auto; max-width: none;"></a>
                    </div>
                </div>
            </div>
        </div>
    </section> -->


    <!-- bottom-banner start here -->
    <section class="home-page-banner">
        <div class="container">
            <div class="row justify-content-center align-items-center">
                
                <div class="col-lg-6" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <div class="image-div">
                        <img class="w-100" src="../../../assets/images/home-new-static/banner/banner.png" alt="">
                    </div>
                </div>

                <div class="col-lg-6" data-aos="fade-left" data-aos-anchor="#example-anchor" data-aos-offset="500" data-aos-duration="500">
                    <div class="text-div">
                        <h1 class="mb-3" id="highlight-effect">
                            Restaurant-First Marketing Approach
                        </h1>
                        <h6 class="mb-5">Our Restaurant-First Marketing Approach centres on creating tailored marketing campaigns that keep your restaurant front and centre. Using innovative strategies and data-driven insights, we connect you with your audience effectively while ensuring clear, results-driven reporting to measure success and ROI.</h6>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- bottom-banner end here  -->

    <!-- three part process start here -->
    <section class="three-sec-all-process" id="three-sec-all-process">
        <div class="container">
            <h3 class="mt-5 text-center">Smart Solutions For A Restaurant’s Success</h3>
            <p class="text-center">Deliver exceptional customer experiences with our custom-built websites, targeted marketing campaigns, and simplified order management systems.</p>
            <div class="row three-step-process">
                <div class="col-lg-4" data-aos="fade-up" data-aos-duration="1000">
                    <figure class="card">
                        <img src="../../../assets/images/home-new-static/process/one1.png" alt="image">
                        <figcaption>
                            <div>
                                
                            </div>
                            <div>
                                <p>Create an intuitive, user-friendly platform for seamless customer engagement and satisfaction.</p>
                            </div>
                        </figcaption>
                    </figure>
                    <h5 class="text-center bold">Custom Websites & Apps</h5>
                </div>
                <div class="col-lg-4"  data-aos="fade-up" data-aos-duration="2000">
                    <figure class="card">
                        <img src="../../../assets/images/home-new-static/process/two1.png" alt="image">
                        <figcaption>
                            <div>
                                
                            </div>
                            <div>
                                <p>Drive more orders and engagement through data-driven, personalised marketing campaigns.</p>
                            </div>
                        </figcaption>
                    </figure>
                    <h5 class="text-center bold">Tailored Marketing Strategies</h5>
                </div>
                <div class="col-lg-4"  data-aos="fade-up" data-aos-duration="3000">
                    <figure class="card">
                        <img src="../../../assets/images/home-new-static/process/three1.png" alt="image">
                        <figcaption>
                            <div>
                                
                            </div>
                            <div>
                                <p>Optimise your workflow with efficient systems, reducing errors and improving customer service..</p>
                            </div>
                        </figcaption>
                    </figure>
                    <h5 class="text-center bold">Effortless Order Management</h5>
                </div>
            </div>
        </div>
    </section>
    <!-- three part process end here -->

    <!-- contact upper footer start here -->
    <section class="contact-upper-footer" id="contact-form-main">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="text-div">
                        <h3>Get in Touch with Us</h3>
                        <p class="mb-3">Have a question or want to get started? Fill out the form below, and our team will be happy to assist you. We’re here to help your restaurant grow with the right marketing solutions.</p>
                    </div>
                </div>
                <div class="col-lg-6" data-aos="zoom-in">
                    <div class="form-div">
                        <form action="" #cf="ngForm" (ngSubmit)="contactsubmit(cf.form.valid,cf)">
                              <div class="form-group mb-2">
                                <label for="contactusrestaurantname">Restaurant's Name <span>*</span></label>
                                <input type="text" class="form-control" id="contactusrestaurantname" aria-describedby="emailHelp" placeholder="Restaurant's Name" [(ngModel)]="postbody.bs_name" name="bs_name" #bs_name="ngModel" required>
                                <div class="alert alert-danger" *ngIf="(bs_name.invalid && bs_name.touched) || (bs_name.invalid && cf.submitted)">
                                    Business name is required
                                </div>
                              </div>
                              <div class="form-group mb-2">
                                <label for="contactusrestaurantaddress">Restaurant's Address <span>*</span></label>
                                <input type="text" class="form-control" id="contactusrestaurantaddress" aria-describedby="emailHelp" placeholder="Restaurant's Address"  [(ngModel)]="postbody.bs_address" name="bs_address" #bs_address="ngModel" required>
                                <div class="alert alert-danger" *ngIf="(bs_address.invalid && bs_address.touched) || (bs_address.invalid && cf.submitted)">
                                    Address and postcode is required
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group mb-2">
                                        <label for="contactusfirstname">Owner's First Name <span>*</span></label>
                                        <input type="name" class="form-control" id="contactusfirstname" aria-describedby="emailHelp" placeholder="First Name" [(ngModel)]="postbody.fname" name="fname" #fname="ngModel" required>
                                        <div class="alert alert-danger" *ngIf="(fname.invalid && fname.touched) || (fname.invalid && cf.submitted)">
                                            First name is required
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group mb-2">
                                        <label for="contactuslastname">Last Name <span>*</span></label>
                                        <input type="name" class="form-control" id="contactuslastname" aria-describedby="emailHelp" placeholder="Last Name" [(ngModel)]="postbody.lname" name="lname" #lname="ngModel" required>
                                        <div class="alert alert-danger" *ngIf="(lname.invalid && lname.touched) || (lname.invalid && cf.submitted)">
                                            Last name is required
                                        </div>
                                    </div>
                                </div>
                              </div>
                              <div class="form-group mb-2">
                                <label for="contactusemail">Email <span>*</span></label>
                                <input type="email" class="form-control" id="contactusemail" aria-describedby="emailHelp" placeholder="Your email"  [(ngModel)]="postbody.email" name="email" #email="ngModel" pattern="^(.+)@(.+)$" required>
                                <div class="alert alert-danger" *ngIf="(email.touched && email.invalid) || (email.invalid && cf.submitted)">
                                    <ng-container *ngIf="email.value ==''">Email is required</ng-container>
                                    <ng-container *ngIf="email.value !=''">Email is Invalid</ng-container>
                                </div>
                              </div>
                              <div class="form-group mb-2">
                                <label for="contactusmobileno">Mobile No <span>*</span></label>
                                <input type="text" class="form-control" id="contactusmobileno" aria-describedby="emailHelp" placeholder="Your Mobile No"  [(ngModel)]="postbody.mobile" name="mobile" #mobile="ngModel" pattern="^0[0-9]\d{9}$" required>
                                
                                <div class="alert alert-danger" *ngIf="(mobile.touched && mobile.invalid) || (mobile.invalid && cf.submitted)">
                                    <ng-container *ngIf="mobile.value ==''">Mobile Number is required</ng-container>
                                    <ng-container *ngIf="mobile.value !=''">
                                    <ng-container *ngIf="mobile != undefined && mobile != null && mobile.value != undefined && mobile.value != null && mobile.value.match(' ') else blankSpaceErr">
                                        Space is not allowed
                                    </ng-container>
                                    <ng-template #blankSpaceErr>
                                        Mobile number must have 11 digit and a leading 0
                                    </ng-template>
                                    </ng-container>
                                </div>
                              </div>
                              <div class="form-group mb-2">
                                <label for="contactuscomment">Comments <span>*</span></label>
                                <textarea class="form-control" id="contactuscomment" rows="3" [(ngModel)]="postbody.comments" name="msg" #msg="ngModel" required></textarea>
                                <div class="alert alert-danger" *ngIf="(msg.invalid && msg.touched) || (msg.invalid && cf.submitted)">
                                    Comments is required
                                </div>
                              </div>
                              <!-- <div class="form-check mb-4">
                                <input type="checkbox" class="form-check-input" id="exampleCheck1">
                                <label class="form-check-label" for="exampleCheck1">Check me out</label>
                              </div> -->
                              <div class="fldarea" >
                                  <div #recaptcha ></div> 
                              </div>
                              <div class="alert alert-danger" *ngIf="showRecaptureError=='yes' && cf.submitted">
                                Captcha is required
                              </div>
                              <button type="submit" class="book-btn ml-0 mt-3">Submit</button>
                              <ng-container *ngIf="contactusSubmit!=''">
                                <br>
                                <br>
                                <div class="d-flex justify-content-center mt-10">
                                    <div class="form-group mb-0 alert-success thank-you-alert-function" >
                                        Thank you. We'll contact you soon.
                                    </div>
                                </div>
                            </ng-container>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- contact upper footer end here -->

    <!-- footer start here --> 
    <footer class="new_footer_area bg_color" data-aos="fade-up" data-aos-anchor-placement="center-bottom">
        <div class="new_footer_top">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="f_widget company_widget wow fadeInLeft" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInLeft;">
                            <a href="#">
                                <img class="footer-logo-main" src="../../../assets/images/home-new-static/header/logo-header.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="f_widget about-widget pl_70 wow fadeInLeft" data-wow-delay="0.6s" style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInLeft;">
                            <h3 class="f-title f_600 t_color f_size_18">Links</h3>
                            <ul class="list-unstyled f_list">
                                <li><a href="/home#home-page-header-section">Home</a></li>
                                <li><a href="/about-us#about-us-header-section">About Us</a></li>
                                <li><a href="https://career.bookyup.co.uk/" target="_blank">Career</a></li>
                                <li><a href="/home#contact-form-main">Contact Us</a></li>
                            </ul>
                        </div>
                    </div>
                    <!-- <div class="col-lg-3 col-md-6">
                        <div class="f_widget company_widget wow fadeInLeft" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInLeft;">
                            <h3 class="f-title f_600 t_color f_size_18">Get in Touch</h3>
                            <p>Have a question or want to get started?</p>
                            <form action="#" class="f_subscribe_two mailchimp" method="post" novalidate="true" _lpchecked="1">
                                <input type="text" name="EMAIL" class="form-control memail" placeholder="Email">
                                <button class="btn btn_get btn_get_two" type="submit">Subscribe</button>
                                <p class="mchimp-errmessage" style="display: none;"></p>
                                <p class="mchimp-sucmessage" style="display: none;"></p>
                            </form>
                        </div>
                    </div> -->
                    <div class="col-lg-3 col-md-6">
                        <div class="f_widget social-widget pl_70 wow fadeInLeft" data-wow-delay="0.8s" style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInLeft;">
                            <h3 class="f-title f_600 t_color f_size_18">Follow Us</h3>
                            <div class="f_social_icon">
                                <a href="javascript:void(0)"><i class="fab fa-facebook"></i></a>
                                <a href="javascript:void(0)"><i class="fa-brands fa-x-twitter"></i></a>
                                <a href="javascript:void(0)"><i class="fab fa-linkedin"></i></a>
                                <a href="javascript:void(0)"><i class="fa-brands fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer_bg">
                <div class="footer_bg_one"></div>
                <div class="footer_bg_two"></div>
            </div>
        </div>
        <div class="footer_bottom">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-sm-12">
                        <p class="mb-0 f_400 text-center">© {{footerCopyrightYear}} All rights reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- footer end here -->
</div>